/* ===== main.js — 묶는 입구: 모듈을 읽는 순서 + 디버그 창구 ===== */
/* ★ 순서가 곧 읽히는 순서다 — 각 모듈은 앞 모듈만 import 하므로(tests/modules.mjs 가 막는다) 이 줄 순서대로 돈다. */
import * as e_math from '../engine/core/math.js';
import * as e_rng from '../engine/core/rng.js';
import * as e_noise from '../engine/core/noise.js';
import * as e_color from '../engine/core/color.js';
import * as e_rle from '../engine/save/rle.js';
import * as e_seal from '../engine/save/seal.js';
import * as e_upgrade from '../engine/save/upgrade.js';
import * as e_store from '../engine/save/store.js';
import * as e_aurl from '../engine/audio/url.js';
import * as e_music from '../engine/audio/music.js';
import * as e_sfx from '../engine/audio/sfx.js';
import * as e_amb from '../engine/audio/ambient.js';
import * as e_image from '../engine/assets/image.js';
import * as e_loop from '../engine/core/loop.js';
import * as e_view from '../engine/platform/viewport.js';
import * as e_actions from '../engine/input/actions.js';
import * as e_pointer from '../engine/input/pointer.js';
import * as e_touch from '../engine/input/touch.js';
import * as e_tilemap from '../engine/tilemap/tilemap.js';
import * as e_light from '../engine/tilemap/light.js';
import * as e_pipeline from '../engine/render/pipeline.js';
import * as e_atlas from '../engine/render/atlas.js';
import * as e_conn from '../engine/render/conn.js';
import * as e_entity from '../engine/entity/entity.js';
import * as e_scenes from '../engine/scene/scenes.js';
import * as e_panels from '../engine/ui/panels.js';
import * as e_tooltip from '../engine/ui/tooltip.js';
import * as e_slots from '../engine/ui/slots.js';
import * as e_ko from '../engine/i18n/ko.js';
import * as e_format from '../engine/i18n/format.js';
import * as e_i18n from '../engine/i18n/i18n.js';
import * as e_mixin from '../engine/core/mixin.js';
import * as e_rhythm from '../engine/rhythm/duel.js';
import * as util from './util.js';
import * as lang from './lang.js';
import * as size from './size.js';
import * as data from './data.js';
/* data.js 에서 나눈 표 — 원래 소스 순서대로 */
import * as d_items from './data/items.js';
import * as d_recipes from './data/recipes.js';
import * as d_start from './data/start.js';
import * as d_enemies from './data/enemies.js';
import * as d_materials from './data/materials.js';
import * as d_skills from './data/skills.js';
import * as d_ruins from './data/ruins.js';
import * as d_npcs from './data/npcs.js';
import * as d_pets from './data/pets.js';
import * as d_story from './data/story.js';
import * as d_quests from './data/quests.js';
import * as d_values from './data/values.js';
import * as d_mobskills from './data/mobskills.js';
import * as d_bossmoves from './data/bossmoves.js';
import * as d_achievements from './data/achievements.js';   // 업적은 장·펫·물건값을 부르므로 맨 뒤(최상위에서 업적을 읽는 표는 없다)
import * as world from './world.js';
/* world.js World 의 메서드 조각 — 읽히는 순간 World.prototype 에 붙는다(클래스처럼 비열거) */
import * as w_plants from './world/plants.js';
import * as w_village from './world/village.js';
import * as w_sky from './world/sky.js';
import * as w_dungeon from './world/dungeon.js';
import * as w_traps from './world/traps.js';
import * as w_ruins from './world/ruins.js';
import * as w_ruin_site from './world/ruin-site.js';
import * as w_caves from './world/caves.js';
import * as w_sea from './world/sea.js';
import * as w_water from './world/water.js';
import * as w_fluid from './world/fluid.js';
import * as w_strata from './world/strata.js';
import * as w_glacier from './world/glacier.js';
import * as tileart from './tileart.js';
/* tileart.js TileArt.paint 의 질감 갈래 — 읽히는 순간 TILE_PAINT 에 붙는다 */
import * as tp_ground from './art/tiles/ground.js';
import * as tp_misc from './art/tiles/misc.js';
import * as tp_factory from './art/tiles/factory.js';
import * as tp_water from './art/tiles/water.js';
import * as tp_village from './art/tiles/village.js';
import * as tp_ruins from './art/tiles/ruins.js';
import * as tp_cave from './art/tiles/cave.js';
import * as itemart from './itemart.js';
/* itemart.js Art.paint 의 그림 갈래 — 읽히는 순간 ITEM_PAINT 에 붙는다 */
import * as ip_glyphs from './art/items/glyphs.js';
import * as ip_gear from './art/items/gear.js';
import * as ip_forms from './art/items/forms.js';
import * as ip_weird from './art/items/weird.js';
import * as ip_trinket from './art/items/trinket.js';
import * as ip_goods from './art/items/goods.js';
import * as ip_farm from './art/items/farm.js';
import * as ip_loot from './art/items/loot.js';
import * as ip_skills from './art/items/skills.js';
import * as ip_ui from './art/items/ui.js';
import * as ip_misc from './art/items/misc.js';
import * as sprites from './sprites.js';
import * as titlebg from './titlebg.js';
import * as items from './items.js';
import * as entity from './entity.js';
/* entity.js Player · Enemy 의 메서드 조각 — 읽히는 순간 프로토타입에 붙는다 */
import * as e_player_combat from './entity/player-combat.js';
import * as e_player_ride from './entity/player-ride.js';
import * as e_player_weird from './entity/player-weird.js';
import * as e_player_move from './entity/player-move.js';
import * as e_enemy_ai from './entity/enemy-ai.js';
import * as e_enemy_skills from './entity/enemy-skills.js';
import * as e_enemy_traits from './entity/enemy-traits.js';
import * as e_enemy_kits from './entity/enemy-kits.js';
import * as e_boss_ai from './entity/boss-ai.js';
import * as e_boss_moves from './entity/boss-moves.js';
import * as e_boss_signature from './entity/boss-signature.js';
import * as e_boss_pool from './entity/boss-pool.js';
import * as e_boss_organ from './entity/boss-organ.js';
import * as e_boss_cocoon from './entity/boss-cocoon.js';
import * as e_boss_hourglass from './entity/boss-hourglass.js';
import * as e_boss_hive from './entity/boss-hive.js';
import * as e_boss_judge from './entity/boss-judge.js';
import * as e_boss_root from './entity/boss-root.js';
import * as e_boss_void from './entity/boss-void.js';
import * as e_boss_storm from './entity/boss-storm.js';
import * as e_boss_cart from './entity/boss-cart.js';
import * as e_boss_watch from './entity/boss-watch.js';
import * as e_boss_spore from './entity/boss-spore.js';
import * as e_boss_prolif from './entity/boss-prolif.js';
import * as e_boss_hepha from './entity/boss-hepha.js';
import * as e_boss_overseer from './entity/boss-overseer.js';
import * as e_boss_arche from './entity/boss-arche.js';
import * as e_boss_shaft from './entity/boss-shaft.js';
import * as e_boss_drowned from './entity/boss-drowned.js';
import * as e_boss_tide from './entity/boss-tide.js';
import * as e_boss_isle from './entity/boss-isle.js';
import * as e_boss_eclipse from './entity/boss-eclipse.js';
import * as e_boss_gaps from './entity/boss-gaps.js';
import * as e_boss_forms from './entity/boss-forms.js';
import * as factory from './factory.js';
/* factory.js 의 Factory 를 나눈 조각 — 틱 · 그리기 */
import * as f_tick from './factory/tick.js';
import * as f_render from './factory/render.js';
import * as f_big from './factory/big.js';
import * as ui from './ui.js';
/* ui.js 의 UI 를 나눈 조각 */
import * as u_tree from './ui/tree.js';
import * as u_quest from './ui/quest.js';
import * as u_craft from './ui/craft.js';
import * as u_machine from './ui/machine.js';
import * as u_shop from './ui/shop.js';
import * as u_tip from './ui/tip.js';
import * as u_portrait from './ui/portrait.js';
import * as u_dialogue from './ui/dialogue.js';
import * as u_hud from './ui/hud.js';
import * as u_motion from './ui/motion.js';
import * as u_process from './ui/process.js';
import * as u_mach_kit from './ui/mach-kit.js';
import * as u_mach_inside from './ui/mach-inside.js';
import * as u_mach_scene from './ui/mach-scene.js';
import * as u_craft_scene from './ui/craft-scene.js';
import * as u_mach_view from './ui/mach-view.js';
import * as u_emoji from './ui/emoji.js';
import * as music from './music.js';
import * as savefmt from './savefmt.js';
import * as game from './game.js';
/* game.js 의 G 를 영역별로 나눈 조각 — 읽히는 순간 G 에 붙는다(조각끼리는 이름이 겹치지 않는다 — tools/regroup.mjs 가 막는다) */
import * as g_shell from './game/shell.js';
import * as g_save from './game/save.js';
import * as g_sound from './game/sound.js';
import * as g_fx from './game/fx.js';
import * as g_skill_art from './game/skill-art.js';
import * as g_status_fx from './game/status-fx.js';
import * as g_mob_fx from './game/mob-fx.js';
import * as g_stage_fx from './game/stage-fx.js';
import * as g_boss_form_fx from './game/boss-form-fx.js';
import * as g_boss_theme_fx from './game/boss-theme-fx.js';
import * as g_mine from './game/mine.js';
import * as g_farm from './game/farm.js';
import * as g_fluid_fx from './game/fluid-fx.js';
import * as g_fishing from './game/fishing.js';
import * as g_fish_duel_art from './game/fish-duel-art.js';
import * as g_fish_duel from './game/fish-duel.js';
import * as g_rides from './game/rides.js';
import * as g_repair from './game/repair.js';
import * as g_weird_fx from './game/weird-fx.js';
import * as g_trinkets from './game/trinkets.js';
import * as g_interact from './game/interact.js';
import * as g_talk from './game/talk.js';
import * as g_quests from './game/quests.js';
import * as g_shop from './game/shop.js';
import * as g_village from './game/village.js';
import * as g_pets from './game/pets.js';
import * as g_boss from './game/boss.js';
import * as g_isle_tiles from './game/isle-tiles.js';
import * as g_isle_lift from './game/isle-lift.js';
import * as g_boss_ice_art from './game/boss-ice-art.js';
import * as g_boss_water_art from './game/boss-water-art.js';
import * as g_boss_hazard_art from './game/boss-hazard-art.js';
import * as g_boss_gap_fx from './game/boss-gap-fx.js';
import * as g_boss_field_art from './game/boss-field-art.js';
import * as g_boss_earth_art from './game/boss-earth-art.js';
import * as g_boss_machine_art from './game/boss-machine-art.js';
import * as g_boss_tell_art from './game/boss-tell-art.js';
import * as g_boss_pool_art from './game/boss-pool-art.js';
import * as g_boss_pool_fx from './game/boss-pool-fx.js';
import * as g_boss_organ_art from './game/boss-organ-art.js';
import * as g_boss_organ_fx from './game/boss-organ-fx.js';
import * as g_boss_cocoon_art from './game/boss-cocoon-art.js';
import * as g_boss_cocoon_fx from './game/boss-cocoon-fx.js';
import * as g_boss_hourglass_art from './game/boss-hourglass-art.js';
import * as g_boss_hourglass_fx from './game/boss-hourglass-fx.js';
import * as g_boss_hive_art from './game/boss-hive-art.js';
import * as g_boss_hive_fx from './game/boss-hive-fx.js';
import * as g_boss_judge_art from './game/boss-judge-art.js';
import * as g_boss_judge_fx from './game/boss-judge-fx.js';
import * as g_boss_root_art from './game/boss-root-art.js';
import * as g_boss_root_fx from './game/boss-root-fx.js';
import * as g_boss_witch_art from './game/boss-witch-art.js';
import * as g_boss_void_art from './game/boss-void-art.js';
import * as g_boss_storm_art from './game/boss-storm-art.js';
import * as g_boss_cart_art from './game/boss-cart-art.js';
import * as g_boss_watch_art from './game/boss-watch-art.js';
import * as g_boss_spore_art from './game/boss-spore-art.js';
import * as g_boss_prolif_art from './game/boss-prolif-art.js';
import * as g_boss_hepha_art from './game/boss-hepha-art.js';
import * as g_boss_overseer_art from './game/boss-overseer-art.js';
import * as g_boss_arche_art from './game/boss-arche-art.js';
import * as g_boss_restorer_art from './game/boss-restorer-art.js';
import * as g_boss_shaft_art from './game/boss-shaft-art.js';
import * as g_boss_drowned_art from './game/boss-drowned-art.js';
import * as g_boss_tide_art from './game/boss-tide-art.js';
import * as g_boss_isle_art from './game/boss-isle-art.js';
import * as g_boss_eclipse_art from './game/boss-eclipse-art.js';
import * as g_boss_eclipse_fx from './game/boss-eclipse-fx.js';
import * as g_boss_arena from './game/boss-arena.js';
import * as g_boss_sig_art from './game/boss-sig-art.js';
import * as g_boss_sig from './game/boss-sig.js';
import * as g_boss_hazards from './game/boss-hazards.js';
import * as g_progress from './game/progress.js';
import * as g_life from './game/life.js';
import * as g_spawn from './game/spawn.js';
import * as g_weather from './game/weather.js';
import * as g_rigs from './game/rigs.js';
import * as g_zones from './game/zones.js';
import * as g_caves from './game/caves.js';
import * as g_meteor from './game/meteor.js';
import * as g_ruins from './game/ruins.js';
import * as g_ruin_events from './game/ruin-events.js';
import * as g_ruin_events_draw from './game/ruin-events-draw.js';
import * as g_ruin_pulse from './game/ruin-pulse.js';
import * as g_ruin_puzzle from './game/ruin-puzzle.js';
import * as g_ruin_puzzle_draw from './game/ruin-puzzle-draw.js';
import * as g_ruin_deep from './game/ruin-deep.js';
import * as g_citadel from './game/citadel.js';
import * as g_memory from './game/memory.js';
import * as g_minimap from './game/minimap.js';
import * as g_render from './game/render.js';
import * as g_render_sky from './game/render-sky.js';
import * as g_render_world from './game/render-world.js';
import * as g_render_actors from './game/render-actors.js';
import * as g_render_chunks from './game/render-chunks.js';
import * as g_perf from './game/perf.js';
import * as g_utility from './game/utility.js';
import * as g_debug_start from './game/debug-start.js';
import * as g_debug_showcase from './game/debug-showcase.js';
import * as g_net from './game/net.js';
import * as g_netui from './game/netui.js';
import * as g_netchat from './game/netchat.js';
import * as g_netprog from './game/netprog.js';

/* data.js 와 나눈 표를 한 묶음으로 — ★ 이름 순이어야 한다(나누기 전 data 모듈 이름공간과 같은 순서 — 같은 물건을 두 표가 가지면
   먼저 만난 경로가 번역 열쇠가 된다). tools/i18n.mjs 의 표 모으기와 같은 순서. */
export const DATA = Object.fromEntries(Object.entries(Object.assign({}, data, d_items, d_recipes, d_start, d_enemies, d_materials, d_skills, d_ruins, d_npcs, d_pets, d_story, d_quests, d_values, d_achievements))
  .sort(([a], [b]) => a < b ? -1 : a > b ? 1 : 0));

/* 원본 언어(ko)가 아니면 — 표(아이템 이름 따위)를 그 언어로 덮고 정적 HTML 글을 옮긴다.
   ★ 게임이 켜지기(DOMContentLoaded → G.init) 전, 표를 읽는 누구보다 먼저여야 한다. 표 경로의 뿌리 순서는
   tools/i18n.mjs extract 와 같아야 한다(같은 물건을 두 표가 나눠 가지면 먼저 만난 경로로 적힌다). */
if (!lang.I18N.isSource) {
  lang.I18N.applyTables(Object.assign({}, size, DATA, world, factory));
  lang.localizeDom(document.documentElement);
  document.documentElement.lang = lang.LANG;
}

/* 디버그 창구 — 콘솔·?debug 도구·tests·tools/*.py 가 예전처럼 G · World · T · WW … 를 이름으로 읽는다.
   ★ 읽기 전용이고 살아 있는 값이다(WW 는 setWorldSize 뒤에 바뀐 값). 게임 코드는 이것을 읽지 말고 import 할 것.
   브라우저가 이미 가진 이름은 덮지 않는다. */
for (const m of [e_math, e_rng, e_noise, e_color, e_rle, e_seal, e_upgrade, e_store, e_aurl, e_music, e_sfx, e_amb, e_image, e_loop, e_view, e_actions, e_pointer, e_touch, e_tilemap, e_light, e_pipeline, e_atlas, e_conn, e_entity, e_scenes, e_panels, e_tooltip, e_slots, e_ko, e_format, e_i18n, e_mixin, e_rhythm, util, lang, size, data, d_items, d_recipes, d_start, d_enemies, d_materials, d_skills, d_ruins, d_npcs, d_pets, d_story, d_quests, d_values, d_mobskills, d_bossmoves, d_achievements, world, w_plants, w_village, w_sky, w_dungeon, w_traps, w_ruins, w_ruin_site, w_caves, w_sea, w_water, w_fluid, w_strata, w_glacier, tileart, tp_ground, tp_misc, tp_factory, tp_water, tp_village, tp_ruins, tp_cave, itemart, ip_glyphs, ip_gear, ip_weird, ip_trinket, ip_goods, ip_farm, ip_loot, ip_forms, ip_skills, ip_ui, ip_misc, sprites, titlebg, items, entity, e_player_combat, e_player_ride, e_player_weird, e_player_move, e_enemy_ai, e_enemy_skills, e_enemy_traits, e_enemy_kits, e_boss_ai, e_boss_moves, e_boss_signature, e_boss_pool, e_boss_organ, e_boss_cocoon, e_boss_hourglass, e_boss_hive, e_boss_judge, e_boss_root, e_boss_void, e_boss_storm, e_boss_cart, e_boss_watch, e_boss_spore, e_boss_prolif, e_boss_hepha, e_boss_overseer, e_boss_arche, e_boss_shaft, e_boss_drowned, e_boss_tide, e_boss_isle, e_boss_eclipse, e_boss_gaps, e_boss_forms, factory, f_tick, f_render, f_big, ui, u_tree, u_quest, u_craft, u_machine, u_shop, u_tip, u_portrait, u_dialogue, u_hud, u_motion, u_process, u_mach_kit, u_mach_inside, u_mach_scene, u_craft_scene, u_mach_view, u_emoji, music, savefmt, game, g_shell, g_save, g_sound, g_fx, g_skill_art, g_status_fx, g_mob_fx, g_stage_fx, g_boss_form_fx, g_boss_theme_fx, g_mine, g_farm, g_fluid_fx, g_fishing, g_fish_duel_art, g_fish_duel, g_rides, g_repair, g_weird_fx, g_trinkets, g_interact, g_talk, g_quests, g_shop, g_village, g_pets, g_boss, g_isle_tiles, g_isle_lift, g_boss_ice_art, g_boss_water_art, g_boss_hazard_art, g_boss_gap_fx, g_boss_field_art, g_boss_earth_art, g_boss_machine_art, g_boss_tell_art, g_boss_pool_art, g_boss_pool_fx, g_boss_organ_art, g_boss_organ_fx, g_boss_cocoon_art, g_boss_cocoon_fx, g_boss_hourglass_art, g_boss_hourglass_fx, g_boss_hive_art, g_boss_hive_fx, g_boss_judge_art, g_boss_judge_fx, g_boss_root_art, g_boss_root_fx, g_boss_witch_art, g_boss_void_art, g_boss_storm_art, g_boss_cart_art, g_boss_watch_art, g_boss_spore_art, g_boss_prolif_art, g_boss_hepha_art, g_boss_overseer_art, g_boss_arche_art, g_boss_restorer_art, g_boss_shaft_art, g_boss_drowned_art, g_boss_tide_art, g_boss_isle_art, g_boss_eclipse_art, g_boss_eclipse_fx, g_boss_arena, g_boss_sig_art, g_boss_sig, g_boss_hazards, g_progress, g_life, g_spawn, g_weather, g_rigs, g_zones, g_caves, g_meteor, g_ruins, g_ruin_events, g_ruin_events_draw, g_ruin_pulse, g_ruin_puzzle, g_ruin_puzzle_draw, g_ruin_deep, g_citadel, g_memory, g_minimap, g_render, g_render_sky, g_render_world, g_render_actors, g_render_chunks, g_perf, g_utility, g_debug_start, g_debug_showcase, g_net, g_netui, g_netchat, g_netprog]) {
  for (const k of Object.keys(m)) {
    if (k in window) continue;
    Object.defineProperty(window, k, { get: () => (m as Bag)[k], configurable: true });
  }
}
